import './career-opportunity.scss';
import { setupLayout } from '../Shared/layout';
import { slideToggle } from '../../src/module/dom';
import { ajaxForm } from '../../src/module/form';
import { appConfig } from '../../src/appConfig';

setupLayout();

document.querySelectorAll('.header').forEach(elem => {
    elem.addEventListener('click', () => {
        elem.classList.toggle('header-active');
        slideToggle(elem.nextElementSibling as HTMLElement);
    });
});

const elementId = 'careerOpportunityApplicationForm';
declare let fbq: (...args: any[]) => void

ajaxForm({
    elementId: elementId,
    beforeSend: () => {
        document.querySelector<HTMLElement>(`#${elementId} .buttonSubmit`).style.display = 'none';
        document.querySelector<HTMLElement>(`#${elementId} .buttonLoading`).style.display = 'block';
        document.querySelector<HTMLElement>(`#${elementId} .buttonError`).style.display = 'none';
    },
    error: (errorText) => {
        document.querySelector<HTMLElement>(`#${elementId} .buttonSubmit`).style.display = 'none';
        document.querySelector<HTMLElement>(`#${elementId} .buttonLoading`).style.display = 'none';
        document.querySelector<HTMLElement>(`#${elementId} .buttonError`).style.display = 'block';
        console.log(errorText);
    },
    processing: () => {
        //upload percentage
    },
    success: () => {
        document.querySelector<HTMLElement>(`#${elementId} .buttonSubmit`).style.display = 'none';
        document.querySelector<HTMLElement>(`#${elementId} .buttonLoading`).style.display = 'none';
        document.querySelector<HTMLElement>(`#${elementId} .buttonError`).style.display = 'none';
        document.querySelector<HTMLElement>(`#${elementId} .buttonSuccess`).style.display = 'block';
        (document.getElementById(elementId) as HTMLFormElement).reset();
        gtag('event', 'apply_job', {
            send_to: appConfig.googleAnalyticsId,
            event_category: 'engagement'
        });
        gtag('event', 'apply_job', {
            send_to: appConfig.googleAnalytics4Id
        });
        fbq('trackCustom', 'ApplyJob');
    },
    finally: () => {
        //finish all job
    }
});
